import { createFileRoute } from "@tanstack/react-router";

import {
  ConsoleKeysPage,
  consoleConnectorsQueryOptions,
  consoleKeysQueryOptions,
} from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/console/keys/")({
  loader: ({ context: { queryClient } }) => {
    void queryClient.ensureQueryData(consoleKeysQueryOptions());
    // Warm the connectors list for the create-wizard resource-policy step.
    void queryClient.ensureQueryData(consoleConnectorsQueryOptions());
  },
  component: ConsoleKeysPage,
});
